(function() {

  'use strict';
  angular.module('eclipseApp.myAccount').controller('changeCallerIdCtrl', ['$scope', '$http', 'uteEndpoint', 'commonService', '$stateParams', '$rootScope', 'data', 'dataLayerService', 'dtmServiceConstants', '$translate', function($scope, $http, uteEndpoint, commonService, $stateParams, $rootScope, data, dataLayerService, dtmServiceConstants, $translate){
    $scope.selectedCTN = data.ctnSelected;
    $scope.isSubscriber = $rootScope.userInfo.profileType.subscriber;
    $scope.isAccountHolder = !($rootScope.userInfo.profileType.subscriber);
    $scope.fNameBannedWordError = $scope.lNameBannedWordError = false;
    $scope.errorFlag = true;
    $scope.ctnSelected = data.ctnSelected;
    $scope.accountNumberSelected = data.accountNumberSelected;
    $scope.accountDetails = commonService.accountDetails;
    //$scope.ctnList = data.ctnList;
    $scope.displayScreen = "";
    $scope.isModalWindow = true;
    $scope.activeCTNS = [];
    $scope.checkBox = {};
    $scope.fNameError = $scope.lNameError = false;
    $scope.errorPayload = {
      page: dtmServiceConstants.dataLayerTrack.page.changeCallerID.error
    };
    $scope.errorFormPayload = {
      page: dtmServiceConstants.dataLayerTrack.page.changeCallerID.start
    };

    //iterates through account overview object to get first name and last name
    $scope.dropDownChange = function(selectedCtn) {
      _.each($scope.accountDetails, function (accountDetail) {
        if(accountDetail.accountNumber == $scope.accountNumberSelected) {
          _.each(accountDetail.subscriberServices, function (subscriberService) {
            if (subscriberService.wireless.subscriberNo === selectedCtn) {
              $scope.ctnSelected = selectedCtn;
              $scope.selectedCTN = selectedCtn;
              $scope.currentFirstName = subscriberService.wireless.firstNameLower;
              $scope.currentLastName = subscriberService.wireless.lastNameLower;
            }
          });
        }
      });
    };

    //getting active ctns
    $scope.activeCTNList = function () {
      _.each($scope.accountDetails, function (accountDetail) {
        if (accountDetail.accountNumber === $scope.accountNumberSelected) {
          _.each(accountDetail.subscriberServices, function (subscriberService) {
            console.log(subscriberService)
            if (subscriberService.wireless && subscriberService.wireless.subscriberStatus && subscriberService.wireless.subscriberStatus.toLowerCase() === 'active') {
              $scope.activeCTNS.push(subscriberService.wireless.subscriberNo);
            }
          })
        }
      })
      console.log($scope.activeCTNS);
    }

    $scope.trackCallerIDChange  = function(step, addBasicSections) {
      var  event = {};
      var  selfServe = {};
      var  page = dtmServiceConstants.dataLayerTrack.page.changeCallerID[step];

      /**
       * Set event for SelfServe Start or Complete
       */
      if (step === 'start') {
        event.selfServeStart = true;
        selfServe = dtmServiceConstants.dataLayerTrack.selfServe.changeCallerID;
      } else if (step === 'complete') {
        event.selfServeComplete = true;
        selfServe = dtmServiceConstants.dataLayerTrack.selfServe.changeCallerID;
      }

      var payload = {
        page: page,
        selfServe: selfServe,
        events: event
      };

      /**
       * Remove empty objects from payload
       */
      if (_.isEmpty(payload.events)) {
        delete payload.events;
      }
      if (_.isEmpty(payload.selfServe)) {
        delete payload.selfServe;
      }
      dataLayerService.trackDataLayer(payload, $scope.isModalWindow, addBasicSections);
    };

    $scope.init = function(){
      $scope.activeCTNList();
      $scope.dropDownChange($scope.ctnSelected);
      $scope.trackCallerIDChange(dtmServiceConstants.actions.startEvent, dtmServiceConstants.dataLayerTrack.basicPayloadSections);
      $scope.$applyAsync(function (){
        $('body.modal-open').addClass('disable-background-scroll'); //disable mobile scroll
      });
    };

    $scope.init();

    //get list of banned words from CMS and store them in angular service
    $http({
      method: 'GET',
      url: 'cms/ute/fido/resource/bannedWordsList.json'
    }).success(function(data) {
      if (data) {
        commonService.listOfBannedWords = data;
      }
    });

    //Function to check offensive names only when both fields are entered
    $scope.checkBadName = function() {
      if ($scope.fName && $scope.lName) {
        var fNameCounter = 0;
        var lNameCounter = 0;

        $.each(commonService.listOfBannedWords, function(key,value){
          $.each (value, function(key1, names){
            if (names && (names.toUpperCase() === $scope.fName.toUpperCase())) {
              fNameCounter++;
            }
            if (names && (names.toUpperCase() === $scope.lName.toUpperCase())) {
              lNameCounter++;
            }
          })
        });

        if (fNameCounter > 0) {
          $scope.fNameError = $scope.fNameBannedWordError = true;
          $scope.fNameClass = "red-border";
        }
        if (lNameCounter > 0) {
          $scope.lNameError = $scope.lNameBannedWordError = true;
          $scope.lNameClass = "red-border";
        }
        if (lNameCounter == 0) {
          $scope.lNameError = $scope.lNameBannedWordError = false;
          $scope.lNameClass = "normal-border";
        }
        if (fNameCounter == 0)  {
          $scope.fNameError = $scope.fNameBannedWordError = false;
          $scope.fNameClass = "normal-border";
        }
      }
    };

    //function to disable button
    $scope.isDisabled = function() {
      if ($scope.fNameBannedWordError || $scope.lNameBannedWordError || $scope.fNameError ||  $scope.lNameError) {
        $scope.buttonClass="disable";
        return true;
      }else if(!$scope.checkBox.checked){
        $scope.buttonClass="disable";
        return true;
      }
      else {
        $scope.buttonClass="";
        return false;
      }
    };

    $scope.checkErrorType = function(formField){
      var errorType = '';
      $scope.checkBadName();
      if(formField && formField.$invalid){
        if(formField.$error.required){
          errorType = 'No input';
        }else if($scope.fNameBannedWordError || $scope.lNameBannedWordError || $scope.fNameError ||  $scope.lNameError){
          errorType = 'System block';
        }else if(formField.$error.pattern){
          errorType = 'User entry';
        }
        return errorType;
      }else if($scope.fNameBannedWordError || $scope.lNameBannedWordError || $scope.fNameError ||  $scope.lNameError){
        errorType = 'System block';
        return errorType;
      }
    };

    $scope.updateCallerId = function() {
      $http({
        method: 'POST',
        url: uteEndpoint('v1/wireless/updatecallerid'),
        data:{
          firstName : $scope.fName,
          lastName : $scope.lName,
          accountNumber : $scope.accountNumberSelected,
          ctn : $scope.ctnSelected
        }
      }).success(function(data) {
        if((data.result == null && data.error == "50000") || (data.result == null && data.error == null)){
          $scope.errorFlag = true;
          $scope.successFlag = false;
          $scope.modalDynamicPixel = 'caller-id-error-screen';
          $scope.displayScreen = "updateFailed";
          $translate('global.message.callerIDFailureMsg').then(function (translatedValues) {
            var dtmErrors = [];
            dtmErrors.push({
              type: dtmServiceConstants.dataLayerTrack.errorType.http,
              code: angular.isString(data.error) ? data.error : '',
              message: translatedValues,
              category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
              API: dtmServiceConstants.dataLayerTrack.page.changeCallerID.errorType.updateFailure
            });
            dataLayerService.trackErrors($scope.errorPayload, dtmErrors, $scope.isModalWindow, dtmServiceConstants.dataLayerTrack.basicPayloadSections);
          });
        }else if((data.error == null || data.error == "null") && (data.result != null && data.result.toLowerCase() == "success")){
          $scope.successFlag = true;
          $scope.errorFlag = false;
          $scope.displayScreen = "updateSuccess";
          $scope.trackCallerIDChange(dtmServiceConstants.actions.completeEvent, dtmServiceConstants.dataLayerTrack.basicPayloadSections);
        }else{
          $scope.errorFlag = true;
          $scope.successFlag = false;
          $scope.modalDynamicPixel = 'caller-id-error-screen';
          $scope.displayScreen = "updateFailed";
          $translate('global.message.callerIDFailureMsg').then(function (translatedValues) {
            var dtmErrors = [];
            dtmErrors.push({
              type: dtmServiceConstants.dataLayerTrack.errorType.http,
              code: angular.isString(data.error) ? data.error : '',
              message: translatedValues,
              category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
              API: dtmServiceConstants.dataLayerTrack.page.changeCallerID.errorType.updateFailure
            });
            dataLayerService.trackErrors($scope.errorPayload, dtmErrors, $scope.isModalWindow, dtmServiceConstants.dataLayerTrack.basicPayloadSections);
          });
        }
      }).error(function(data, status){
        $scope.errorFlag = true;
        $scope.successFlag = false;
        $scope.modalDynamicPixel = 'caller-id-error-screen';
        $scope.displayScreen = "updateFailed";
        $translate('global.message.callerIDFailureMsg').then(function (translatedValues) {
          var dtmErrors = [];
          dtmErrors.push({
            type: dtmServiceConstants.dataLayerTrack.errorType.http,
            code: status ? status : '',
            message: translatedValues,
            category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
            API: dtmServiceConstants.dataLayerTrack.page.changeCallerID.errorType.updateFailure
          });
          dataLayerService.trackErrors($scope.errorPayload, dtmErrors, $scope.isModalWindow, dtmServiceConstants.dataLayerTrack.basicPayloadSections);
        });

      });
    };

    $scope.openCallerIDModal = function(){
      $scope.errorFlag = false;
      $scope.successFlag = false;
      $scope.modalDynamicPixel = '';
      $scope.displayScreen = "";
      $scope.trackCallerIDChange(dtmServiceConstants.actions.startEvent, dtmServiceConstants.dataLayerTrack.basicPayloadSections);
    };

    $scope.enableMobileScroll = function(){
      $('body.modal-open').removeClass('disable-background-scroll');
    };

  }]);
})();
